<template>
<div>
    <h1 class="display-heading">Dashboard</h1>

    <div class="row">
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Last Update Medicine List Date</h5>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{latestDrugUpdateDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Patients
                        <small>(based on name of individual)</small>
                    </h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalPatientsDatePicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalPatients">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalPatients.count}}</span>
                            <span class="ml-3">Patient<span v-if="totalPatients.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Pending Medicine List</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalPendingMedicineListPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalPendingMedicineList">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalPendingMedicineList.count}}</span>
                            <span class="ml-3">Medicine List<span v-if="totalPendingMedicineList.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total In-Preparation Medicine List</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalInPreparationMedicineListPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalInPreparationMedicineList">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalInPreparationMedicineList.count}}</span>
                            <span class="ml-3">Medicine List<span v-if="totalInPreparationMedicineList.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Delivered Medicine List</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalDeliveredMedicineListPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalDeliveredMedicineList">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalDeliveredMedicineList.count}}</span>
                            <span class="ml-3">Medicine List<span v-if="totalDeliveredMedicineList.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Outstanding Payment</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalOutstandingPaymentPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalOutstandingPayment">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM{{totalOutstandingPayment.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Received Payment</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalReceivedPaymentPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalReceivedPayment">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM{{totalReceivedPayment.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import datetimePicker from '@/components/datetime-picker';
import { convertToUserReadableDate } from '@/utilities';
export default {
    'name': 'PharmacyAdminDashboard',
    'components': {
        datetimePicker
    },
    data () {
        return {
            'latestDrugUpdateDate': '-',
            'totalPatients': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalPendingMedicineList': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalInPreparationMedicineList': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalDeliveredMedicineList': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalOutstandingPayment': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            },
            'totalReceivedPayment': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            }
        };
    },
    mounted () {
        this.getDashboard();
    },
    'methods': {
        getDashboard () {
            this.axios.get('Dashboard/GetPharmacyAdminDashboard').then(({ data }) => {
                if (data.data.ldud) {
                    this.latestDrugUpdateDate = convertToUserReadableDate(data.data.ldud);
                }

                if (data.data.tup) {
                    this.setTotalPatients(data.data.tup);
                }

                if (data.data.tpp) {
                    this.setTotalPendingMedicineList(data.data.tpp);
                }

                if (data.data.tipp) {
                    this.setTotalInPreparationMedicineList(data.data.tipp);
                }

                if (data.data.tdp) {
                    this.setTotalDeliveredMedicineList(data.data.tdp);
                }

                if (data.data.top) {
                    this.setTotalOutstandingPayment(data.data.top);
                }

                if (data.data.tppf) {
                    this.setTotalReceivedPayment(data.data.tppf);
                }
            });
        },
        setTotalPatients (data) {
            this.totalPatients.startDate = moment(data.sd);
            this.totalPatients.endDate = moment(data.ed);
            this.totalPatients.count = data.c;

            this.$refs.totalPatientsDatePicker.setDate(this.totalPatients.startDate, this.totalPatients.endDate);
        },
        viewTotalPatients () {
            let { startDate, endDate } = this.$refs.totalPatientsDatePicker.getDates();

            this.axios.post('Dashboard/GetPharmacyTotalUniquePatients',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalPatients(data.data);
            });
        },
        setTotalPendingMedicineList (data) {
            this.totalPendingMedicineList.startDate = moment(data.sd);
            this.totalPendingMedicineList.endDate = moment(data.ed);
            this.totalPendingMedicineList.count = data.c;

            this.$refs.totalPendingMedicineListPicker.setDate(this.totalPendingMedicineList.startDate, this.totalPendingMedicineList.endDate);
        },
        viewTotalPendingMedicineList () {
            let { startDate, endDate } = this.$refs.totalPendingMedicineListPicker.getDates();

            this.axios.post('Dashboard/GetPharmacyTotalPendingPrescriptions',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalPendingMedicineList(data.data);
            });
        },
        setTotalInPreparationMedicineList (data) {
            this.totalInPreparationMedicineList.startDate = moment(data.sd);
            this.totalInPreparationMedicineList.endDate = moment(data.ed);
            this.totalInPreparationMedicineList.count = data.c;

            this.$refs.totalInPreparationMedicineListPicker.setDate(this.totalInPreparationMedicineList.startDate, this.totalInPreparationMedicineList.endDate);
        },
        viewTotalInPreparationMedicineList () {
            let { startDate, endDate } = this.$refs.totalInPreparationMedicineListPicker.getDates();

            this.axios.post('Dashboard/GetPharmacyTotalInPreparationPrescriptions',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalInPreparationMedicineList(data.data);
            });
        },
        setTotalDeliveredMedicineList (data) {
            this.totalDeliveredMedicineList.startDate = moment(data.sd);
            this.totalDeliveredMedicineList.endDate = moment(data.ed);
            this.totalDeliveredMedicineList.count = data.c;

            this.$refs.totalDeliveredMedicineListPicker.setDate(this.totalDeliveredMedicineList.startDate, this.totalDeliveredMedicineList.endDate);
        },
        viewTotalDeliveredMedicineList () {
            let { startDate, endDate } = this.$refs.totalDeliveredMedicineListPicker.getDates();

            this.axios.post('Dashboard/GetPharmacyTotalDeliveredPrescriptions',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalDeliveredMedicineList(data.data);
            });
        },
        setTotalOutstandingPayment (data) {
            this.totalOutstandingPayment.startDate = moment(data.sd);
            this.totalOutstandingPayment.endDate = moment(data.ed);
            this.totalOutstandingPayment.amount = data.a;

            this.$refs.totalOutstandingPaymentPicker.setDate(this.totalOutstandingPayment.startDate, this.totalOutstandingPayment.endDate);
        },
        viewTotalOutstandingPayment () {
            let { startDate, endDate } = this.$refs.totalOutstandingPaymentPicker.getDates();

            this.axios.post('Dashboard/GetPharmacyTotalOutstandingPayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalOutstandingPayment(data.data);
            });
        },
        setTotalReceivedPayment (data) {
            this.totalReceivedPayment.startDate = moment(data.sd);
            this.totalReceivedPayment.endDate = moment(data.ed);
            this.totalReceivedPayment.amount = data.a;

            this.$refs.totalReceivedPaymentPicker.setDate(this.totalReceivedPayment.startDate, this.totalReceivedPayment.endDate);
        },
        viewTotalReceivedPayment () {
            let { startDate, endDate } = this.$refs.totalReceivedPaymentPicker.getDates();

            this.axios.post('Dashboard/GetPharmacyTotalDisbursedPayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalReceivedPayment(data.data);
            });
        }

    }
};
</script>

<style>

</style>
